import checkPartnerCooperationAgreementStatus from "@/shared/router/guards/checkPartnerCooperationAgreementStatus";

export default {
  default: [
    {
      path: "/spaar-contracten",
      name: "fundingContracts.table",
      component: () => import("./views/FundingContractTableView.vue"),
      beforeEnter: checkPartnerCooperationAgreementStatus
    },
    {
      path: "/spaar-contract/aanmaken",
      name: "fundingContracts.create",
      component: () => import("./views/FundingContractFormView.vue"),
      beforeEnter: checkPartnerCooperationAgreementStatus
    },
    {
      path: "/spaar-contract/:id/wijzigen",
      name: "fundingContracts.edit",
      component: () => import("./views/FundingContractFormView.vue"),
      beforeEnter: checkPartnerCooperationAgreementStatus
    },
    {
      path: "/spaar-contract/:id/verklaring-herkomst-middelen",
      name: "fundingContracts.declarationOfSourceOfFunds.edit",
      component: () => import("./views/DeclarationOfSourceOfFundsFormView.vue"),
      beforeEnter: checkPartnerCooperationAgreementStatus
    },
    {
      path: "/spaar-contract/:id",
      name: "fundingContracts.view",
      component: () => import("./views/FundingContractDetailsView.vue"),
      beforeEnter: checkPartnerCooperationAgreementStatus
    }
  ]
};
